// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__2Upg1","active":"Sidebar_active__16DEZ","textlink":"Sidebar_textlink__1Zp-v"};